import styled, { keyframes } from 'styled-components'
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`
export const PositionListCardContainer = styled.div`
  border-radius: 14px;
  background: ${({ theme }) => theme.bg1};
  padding: 20px;
  animation: ${fadeIn} 0.5s ease-out;
  .responsive-text {
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
`

export const PositionListCardPriceContainer = styled.div`
  margin-top: 12px;
  display: flex;
  min-height: 80px;
  flex-direction: column;
  gap: 4px;
  overflow: auto;
  width: 48%;
  border-radius: 16px;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.bg2};
`
